import {
  Badge,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Checkbox,
  Input,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../components/ui"

const sampleProducts = [
  { id: "audit", name: "Website Audit", owner: "Platform", status: "Active" },
  { id: "ga4", name: "GA4 Audit", owner: "Analytics", status: "Active" },
  { id: "template", name: "GA4 Template", owner: "Analytics", status: "In Review" },
  { id: "org", name: "Organization Admin", owner: "Operations", status: "Beta" },
]

const sampleStatuses = [
  { label: "Active", variant: "accent" },
  { label: "Beta", variant: "outline" },
  { label: "In Review", variant: "subtle" },
]

export default function ComponentLibrary() {
  return (
    <div className="page-container page-container--wide ui-stack ui-stack--xl">
      <div className="ui-page-header">
        <div className="ui-stack ui-stack--xs">
          <h1 className="ui-page-title">Interface Library</h1>
          <p className="ui-subtitle">
            Preview the shared building blocks used throughout TuneUp. Apply
            these components to keep the experience cohesive.
          </p>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Buttons</CardTitle>
          <CardDescription>
            Use button variants to communicate priority, tone, and intent.
          </CardDescription>
        </CardHeader>
        <CardContent className="ui-stack ui-stack--md">
          <div className="ui-button-row">
            <Button>Primary</Button>
            <Button variant="secondary">Secondary</Button>
            <Button variant="outline">Outline</Button>
            <Button variant="ghost">Ghost</Button>
            <Button variant="destructive">Destructive</Button>
          </div>
          <div className="ui-button-row">
            <Button size="sm">Small</Button>
            <Button size="md">Medium</Button>
            <Button size="lg">Large</Button>
            <Button fullWidth>Full-width</Button>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Form inputs</CardTitle>
          <CardDescription>
            Input fields and checkboxes share spacing, colors, and focus states.
          </CardDescription>
        </CardHeader>
        <CardContent className="ui-grid ui-grid--form">
          <Input label="Organization name" placeholder="Acme Motors" />
          <Input label="Website" placeholder="https://example.com" />
          <Input label="Contact email" type="email" placeholder="dealer@example.com" />
          <Checkbox
            label="Enable weekly reports"
            description="Send a summary email every Monday morning."
            defaultChecked
          />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Status badges</CardTitle>
          <CardDescription>
            Badges highlight state and can be embedded within cards, tables, or headings.
          </CardDescription>
        </CardHeader>
        <CardContent className="ui-chip-row">
          {sampleStatuses.map((status) => (
            <Badge key={status.label} variant={status.variant}>
              {status.label}
            </Badge>
          ))}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Data tables</CardTitle>
          <CardDescription>
            Tables include responsive scrolling, zebra striping, and hover states.
          </CardDescription>
        </CardHeader>
        <CardContent className="ui-stack ui-stack--md">
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeaderCell>Product</TableHeaderCell>
                  <TableHeaderCell>Owner</TableHeaderCell>
                  <TableHeaderCell>Status</TableHeaderCell>
                  <TableHeaderCell align="right">Actions</TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sampleProducts.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.owner}</TableCell>
                    <TableCell>
                      <Badge
                        variant={
                          row.status === "Active"
                            ? "accent"
                            : row.status === "Beta"
                              ? "outline"
                              : "subtle"
                        }
                      >
                        {row.status}
                      </Badge>
                    </TableCell>
                    <TableCell align="right">
                      <div className="ui-button-row ui-button-row--compact ui-button-row--align-end">
                        <Button size="sm" variant="ghost">
                          View
                        </Button>
                        <Button size="sm" variant="destructive">
                          Remove
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </div>
  )
}
